import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const Ephemeral = (props) => (<Svg {...props}>
    <Path d="M7.333 7.734h.4V4.667a.267.267 0 1 1 .534 0V8A.267.267 0 0 1 8 8.267H6a.267.267 0 0 1 0-.533h1.333ZM4.518 2.79a6.267 6.267 0 1 1 6.964 10.42A6.267 6.267 0 0 1 4.518 2.79Zm.297 9.977a5.734 5.734 0 1 0 6.37-9.535 5.734 5.734 0 0 0-6.37 9.535Z" stroke={props?.color ?? props?.stroke ?? '#fff'} strokeWidth={0.8}/>
  </Svg>);
export default Ephemeral;
